import React, { useState, useEffect } from "react";
import "./MootCourtHall.scss";

import img from "../../assets/Infrastructure/Moot Court Hall/img (1).jpeg";
import img1 from "../../assets/Infrastructure/Moot Court Hall/img (2).jpeg";
import img2 from "../../assets/Infrastructure/Moot Court Hall/img (3).jpeg";
import img3 from "../../assets/Infrastructure/Moot Court Hall/img (4).jpeg";
import img4 from "../../assets/Infrastructure/Moot Court Hall/img (5).jpeg";
import img5 from "../../assets/Infrastructure/Moot Court Hall/img (6).jpeg";
import img6 from "../../assets/Infrastructure/Moot Court Hall/img (7).jpeg";
import img7 from "../../assets/Infrastructure/Moot Court Hall/img (8).jpeg";

const images = [img, img1, img2, img3, img4, img5, img6, img7];

const MootCourtHall = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  return (
    <section className="moot-court">
      <div className="container">
        <h1 className="page-title">MOOT COURT HALL</h1>

        {/* IMAGE CAROUSEL */}
        <div className="moot-carousel">
          <button className="arrow left" onClick={prevSlide}>‹</button>

          {images.map((image, index) => (
            <div
              key={index}
              className={`slide ${index === current ? "active" : ""}`}
            >
              <img src={image} alt={`Moot Court ${index + 1}`} />
            </div>
          ))}

          <button className="arrow right" onClick={nextSlide}>›</button>
        </div>

        {/* CONTENT */}
        <div className="content-card">
          <p className="intro">
            The institution has a well-furnished Moot Court Hall{" "}
            designed to simulate real court proceedings and professional legal
            practice.
          </p>

          <p>
            Equipped with comfortable seating and a courtroom-like
            environment, the hall offers students hands-on training in advocacy,
            legal reasoning, and presentation skills.
          </p>

          <p>
            Moot court competitions are conducted regularly to
            encourage students to develop advocacy skills and gain practical
            exposure. Students are motivated to participate in{" "}
            State-level and National-level moot court competitions.
          </p>

          <p>
            Guided by expert faculty coordinators, students are
            trained in legal research, drafting, and memorial writing.
            The experience builds confidence in oral arguments,
            sharpens presentation skills, and helps students prepare for a
            successful legal career.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MootCourtHall;
